import o from "./index618.js";
import { withInstall as t } from "./index604.js";
const l = t(o);
export {
  l as ElCollapseTransition,
  l as default
};
